const processInclude = require('./util');

$(document).ready(() => {
    processInclude(require('./product/plpAddToCart'));
});
